import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';

export class quickLinks {
	$scope: any = $('.quick-links--container');

	hoverComponent(): void {
		let _self = this;
		if(_self.$scope.length == 0) {return;}
		_self.$scope.find('.links-icon--container img').bind('mouseenter mouseleave', function() {
			$(this).attr({
				'src': $(this).attr('data-hover-src'),
				'data-hover-src': $(this).attr('src')
			})
		});
	}
}

let scope:Element = document.querySelector('.quick-links--container');
if (scope){
	try {
		let quicklinks = new quickLinks();
				quicklinks.hoverComponent();
	} catch(e) {console.error(e);}
}
